module.exports = __webpack_public_path__ + "259b0d05.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gogovan-desktop.jpg
// module id = 824
// module chunks = 0 1 2 3 4 5